import React, { useEffect } from 'react';
import {
  Await,
  useLoaderData,
} from '@tanstack/react-router';

import { useStore } from '../store';

import { APIregisterMemoryView } from '../api/Memory';

import MemoryTimelineHeader from '../components/Memory/TimelineHeader';
import MemoryType from '../components/Memory/Type';
import MemorySharedBy from '../components/Memory/SharedBy';
import MemoryMeta from '../components/Memory/Meta';
import MemoryAssets from '../components/Memory/Assets';
import MemoryContent from '../components/Memory/Content';
import MemoryReactions from '../components/Memory/Reactions';
import MemoryComments from '../components/Memory/Comments';
import Notices from '../components/Notices';
import LeaveResponseCTA from '../components/LeaveResponseCTA';
import MemoryFooter from '../components/Memory/Footer';
import Loading from '../components/Loading';

import '@awesome.me/webawesome/dist/components/button/button.js';
import '@awesome.me/webawesome/dist/components/callout/callout.js';

import type { Comment } from '../types/comment';

const MemoryViewPublic: React.FC = () => {
  const {
    memory,
    comments,
    timeline,
  } = useLoaderData({ strict: false });

  const { profile } = useStore((state) => state);

  useEffect(() => {
    APIregisterMemoryView(memory.id, timeline?.id);
  }, [memory.id, timeline?.id]);

  if (!profile) {
    return null;
  }

  return (
    <>
      {timeline && (
        <MemoryTimelineHeader
          memory={memory}
          timeline={timeline}
        />
      )}
      <div className="container memory-view-container memory-view-public-container">
        <div className="memory-view wa-stack">
          <Notices />
          <MemoryType memory={memory} />
          <MemorySharedBy memory={memory} />
          {memory.title && (
            <h1>{memory.title}</h1>
          )}
          {memory.variant === 'memory' && (
            <MemoryMeta memory={memory} />
          )}
          <MemoryAssets memory={memory} />
          <MemoryContent memory={memory} />
          <MemoryReactions memory={memory} />
          <Await promise={comments as Promise<Comment[]>} fallback={<Loading />}>
            {(comments) => (
              <MemoryComments
                memoryId={memory.id}
                comments={comments}
                commentsCount={memory.comments_count}
                commentsAllowed={memory.allow_comments}
              />
            )}
          </Await>
          <LeaveResponseCTA />
          <MemoryFooter />
        </div>
      </div>
    </>
  );
}

export default MemoryViewPublic;
